import { useState } from 'react';
import { Loader2, KeyRound } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { formatOrderNumberLabel } from '../lib/orderUtils';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from './ui/input-otp';

export default function PickupVerificationModal({ open, order, onClose, onVerified }) {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      setCode('');
      onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code.length !== 6 || !order) return;
    setSubmitting(true);
    try {
      await onVerified(order.order_id, code);
      setCode('');
    } finally {
      setSubmitting(false);
    }
  };

  if (!order) return null;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="pickup-verification-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="w-5 h-5" />
            Verify pickup
          </DialogTitle>
          <DialogDescription>
            Ask <span className="font-medium text-foreground">{order.student_name}</span> for their
            6-digit pickup code, then enter it below.
          </DialogDescription>
        </DialogHeader>

        <p className="text-sm text-muted-foreground font-mono">
          Order {formatOrderNumberLabel(order)}
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex justify-center">
            <InputOTP maxLength={6} value={code} onChange={setCode}>
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>

          <div className="flex gap-2">
            <Button type="button" variant="outline" className="flex-1" onClick={onClose} disabled={submitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1"
              disabled={submitting || code.length !== 6}
              data-testid="confirm-pickup-code-btn"
            >
              {submitting ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Verifying…
                </>
              ) : (
                'Confirm picked up'
              )}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
